import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../theme/ISpcTheme';

export type GenericAccordionClasses = 'accordionPaper' | 'expandIcon' | 'accordionDetails' | 'accordionSummary';

const genericAccordionStyles = makeStyles<ISpcTheme, GenericAccordionClasses>(
  theme => ({
    accordionPaper: {
      background: theme.palette.common.white,
      border: 'none',
    },
    expandIcon: {
      fontSize: theme.typography.fontXXL,
    },
    accordionSummary: {
      padding: 0,
      background: theme.palette.common.white,
      cursor: 'default',
    },
    accordionDetails: {
      paddingTop: 5,
      border: 'none',
    },
  }),
  { name: 'Customise_GenericAccordion' },
);

export default genericAccordionStyles;
